import AlertMessage from 'src/components/ui-components/AlertMessage';
import axios from '../../lib/axios';
import { MasterModel, ThemeJsonData, ThemeUpdatePayload } from './Types';

const API_URLS = {
  GET_THEME_JSON_FROM_APPKEY: `/ThemeJson/GetThemeJsonFromAppKey`,
  UPDATE_THEME_JSON: `/ThemeJson/AddUpdateThemeJson`,
  GET_THEME_PAGE_FIELDS: `/ThemePageFields/GetThemePageFields`,
  GET_FONT_FAMILY_MASTER: `/FontFamilyMaster/GetFontFamilyMaster`,
  GET_FONT_WEIGHT_MASTER: `/FontWeightMaster/GetFontWeightMaster`,
  GET_FONT_SIZE_MASTER: `/FontSizeMaster/GetFontSizeMaster`,
  GET_ICON_SIZE_MASTER: `/IconSizeMaster/GetIconSizeMaster`
};

export const getThemeJson = async(): Promise<any> => {
  const response = await axios.get<ThemeJsonData[]>(API_URLS.GET_THEME_JSON_FROM_APPKEY);
  return response?.data || {};
};

export const updateThemeJson = async (data: ThemeUpdatePayload): Promise<any> => {
  try {
    const response = await axios.post<any>(API_URLS.UPDATE_THEME_JSON, data);
    if (response?.data?.isSuccess) {
      AlertMessage({type: 'success', msg:response.data.message});
      return true;
    } else {
      return false;
    }
  } catch {
    AlertMessage({ type: 'error', msg: 'Failed to update Theme'});
    return false;
  }
};

export const getThemePageFields = async(): Promise<any> => {
  const response = await axios.get(API_URLS.GET_THEME_PAGE_FIELDS);
  return response?.data || [];
};

export const getFontFamilyMaster = async(): Promise<MasterModel[]> => {
  const response = await axios.get<MasterModel[]>(API_URLS.GET_FONT_FAMILY_MASTER);
  return response?.data || [];
};

export const getFontWeightMaster = async(): Promise<MasterModel[]> => {
  const response = await axios.get<MasterModel[]>(API_URLS.GET_FONT_WEIGHT_MASTER);
  return response?.data || [];
};

export const getFontSizeMaster = async(): Promise<any> => {
  const response = await axios.get(API_URLS.GET_FONT_SIZE_MASTER);
  return response?.data || [];
};

export const getIconSizeMaster = async(): Promise<any> => {
  const response = await axios.get(API_URLS.GET_ICON_SIZE_MASTER);
  return response?.data || [];
};
